import React from "react";
import KegiatanMain from "../../../components/Katalog/Admin/KegiatanMain/KegiatanMain";

const KegiatanView = () => {
  return (
    <React.Fragment>
      <KegiatanMain />
    </React.Fragment>
  );
};

export default KegiatanView;
